import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import CartPage from "../components/common/headers/common/cart-header";
import ConfirmModal from "../components/common/ConfirmModal";
import { removeFromCart, addCartToServer } from "../actions";
import { getCartTotal } from "../services";
import classes from "./CartContainer.module.scss";

const CartContainer = ({ cartList, total, symbol, removeFromCart, addCartToServer, profileData, history }) => {
  const [button, setButton] = useState("Check For Price Changes");
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  // Item is kept after close so its name survives the modal's fade-out.
  const [itemToRemove, setItemToRemove] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const isLoggedIn =
    (profileData && profileData.user_type === "CUSTOMER") ||
    (localStorage.getItem("user_type") === "CUSTOMER" &&
      !!localStorage.getItem("token"));
  const checkoutPath = `${process.env.PUBLIC_URL}${
    isLoggedIn ? "/checkout" : "/checkout-auth"
  }`;

  useEffect(() => {
    if (button == "please wait...") setButton("Price updated");
  }, [cartList]);

  useEffect(() => {
    const unlisten = history.listen((location) => {
      setCurrentPath(location.pathname);
    });
    return () => unlisten();
  }, [history]);

  const requestRemove = (item) => {
    setItemToRemove(item);
    setConfirmOpen(true);
  };

  const confirmRemove = () => {
    setConfirmOpen(false);
    if (!itemToRemove) return;
    removeFromCart(itemToRemove, itemToRemove.selectedVariant);
    addCartToServer();
  };

  const isCartPage = currentPath.endsWith("/cart");
  const isCheckoutPage = currentPath.endsWith("/checkout") || currentPath.endsWith("/checkout-auth");
  const hideDropdown = isCartPage || currentPath.endsWith("/checkout");
  const hideCheckoutBtn = isCheckoutPage;

  return (
    <li className={`${classes.cart_trigger} onhover-div mobile-cart`}>
      <div className="uk-flex-inline">
        <Link to={`${process.env.PUBLIC_URL}/cart`}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
          >
            <path
              d="M15.3555 8.38839V7.36915C15.3555 4.96476 13.4063 3.01562 11.002 3.01562C8.59758 3.01562 6.64844 4.96476 6.64844 7.36915V8.38839"
              stroke="black"
              strokeLinecap="square"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.5053 18.9844L19.4798 6.74454L2.52148 6.74454L3.49596 18.9844L18.5053 18.9844Z"
              stroke="black"
              strokeLinecap="round"
            />
          </svg>
        </Link>
        {cartList.length > 0 && (
          <span
            className={classes.utilityCount}
          >
            {cartList.length}
          </span>
        )}
      </div>
      {!hideDropdown && cartList.length > 0 &&
        (<ul className={classes.cart_dropdown}>
          <li className={classes.items_wrapper}>
            {cartList
              .slice()
              .reverse()
              .map((item, index) => (
                <CartPage
                  key={index}
                  item={item}
                  total={total}
                  symbol={symbol}
                  removeFromMiniCart={requestRemove}
                />
              ))}
          </li>
          {cartList.length > 0 && (
            <>
              <li className={classes.total}>
                <p className={classes.total_price_text}>subtotal :</p>
                <p className={classes.total_price}>
                  {symbol}
                  {total}
                </p>
              </li>
              <li className={classes.action_btn}>
                <Link
                  to={`${process.env.PUBLIC_URL}/cart`}
                  className={classes.primary_btn}
                >
                  <b>VIEW CART</b>
                </Link>
                {!hideCheckoutBtn && (
                  <Link
                    to={checkoutPath}
                    className={classes.outline_btn}
                  >
                    <b>CHECKOUT</b>
                  </Link>
                )}
              </li>
            </>
          )}
        </ul>)}
      <ConfirmModal
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={confirmRemove}
        title="Remove item?"
        message={
          itemToRemove
            ? `Are you sure you want to remove "${itemToRemove.name}" from your cart?`
            : ""
        }
        confirmText="Remove"
        cancelText="Cancel"
      />
    </li>
  );
};

function mapStateToProps(state, ownProps) {
  return {
    cartList: state.cartList.cart,
    extendedItems: state.cartList.extended_cart,
    total: getCartTotal(state.cartList.cart),
    symbol: state.data.symbol,
    profileData: state.data.profile_data,
  };
}
export default withRouter(
  connect(mapStateToProps, { removeFromCart, addCartToServer })(CartContainer)
);
